import React from 'react';
import { deckPages } from '../../data/deck';
interface PageNavProps {
  active: string;
}

/** Quiet dot rail for moving through the presentation. */
export function PageNav({
  active
}: PageNavProps) {
  const activeIndex = Math.max(0, deckPages.findIndex(page => page.id === active));
  const goTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <nav aria-label="Presentation pages" className="fixed right-5 top-1/2 z-40 hidden -translate-y-1/2 flex-col items-end gap-3 lg:flex" data-id="element-267" data-mp="cugqlh9a5dsm">
      {deckPages.map((page, i) => {
      const isActive = i === activeIndex;
      return <button key={page.id} type="button" onClick={() => goTo(page.id)} aria-label={`Page ${i + 1}: ${page.label}`} aria-current={isActive ? 'true' : undefined} className="group flex items-center gap-3 focus:outline-none" data-id="element-268" data-mp="3v7ew03oucyu6" data-mpi={i}>
            <span className="pointer-events-none whitespace-nowrap rounded-full bg-white px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.16em] text-[var(--fg)] opacity-0 shadow-sm ring-1 ring-[var(--fg)]/10 transition-opacity group-hover:opacity-100 group-focus-visible:opacity-100" data-id="element-269" data-mp="3hcclxprv4pyb">
              {String(i + 1).padStart(2, '0')} · {page.label}
            </span>
            <span className={['block rounded-full transition-all duration-300 group-focus-visible:ring-2 group-focus-visible:ring-[var(--brand)] group-focus-visible:ring-offset-2', isActive ? 'h-6 w-1.5 bg-[var(--brand)]' : 'h-1.5 w-1.5 bg-[var(--fg)]/20 group-hover:bg-[var(--fg)]/50'].join(' ')} data-id="element-270" data-mp="3xzknduoc8qh" />
          </button>;
    })}
      <span className="mt-2 text-[10px] font-semibold tabular-nums tracking-[0.12em] text-[var(--fg)]/40" data-id="element-271" data-mp="2eozn2dm932ab">
        {String(activeIndex + 1).padStart(2, '0')}/{String(deckPages.length).padStart(2, '0')}
      </span>
    </nav>;
}